// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cru-resource-footer{display:flex;justify-content:flex-end;margin-top:20px}.cru-resource-footer .btn{margin-left:20px}", ""]);
// Exports
module.exports = exports;
